import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

// Bar Ball recovery outcomes use their own states; the catch/hit-ground
// outcomes reuse the Rebound Net outcome states. When a play hit the goalpost
// we serialize all of them under the BBAR prefix so legacy output stays
// coherent (this serializer is registered before ReboundNetFragmentSerializer,
// so it wins dispatch for goalpost plays).
const RESULT_MAP = {
    [FootballState.BarBallRecoveredKicking]: "K",
    [FootballState.BarBallRecoveredReceiving]: "R",
    [FootballState.ReboundNetCaughtOffense]: "CO",
    [FootballState.ReboundNetCaughtDefense]: "CD",
    [FootballState.ReboundNetHitGround]: "HG"
};

// Outcomes shared with the Rebound Net flow only belong to Bar Ball when the
// ball actually hit the goalpost.
const SHARED_STATES = [
    FootballState.ReboundNetCaughtOffense,
    FootballState.ReboundNetCaughtDefense,
    FootballState.ReboundNetHitGround
];

export class BarBallFragmentSerializer extends FragmentSerializer {
    applicable(fragment, play) {
        if (!(fragment.associatedState in RESULT_MAP)) {
            return false;
        }
        if (SHARED_STATES.includes(fragment.associatedState)) {
            return Boolean(
                play && play.historyContains(FootballState.HitGoalpost)
            );
        }
        return true;
    }

    getRawFragment(play, serializationContext, fragment) {
        const result = RESULT_MAP[fragment.associatedState];

        const spot = this.resolveFormattedFieldPosition(
            serializationContext,
            fragment.getFieldPosition()
        );

        // HitGround has no player, only a dead-ball position.
        if (fragment.associatedState === FootballState.ReboundNetHitGround) {
            return `BBAR:${result},${spot}`;
        }

        const team = this.resolveTeam(
            serializationContext,
            fragment.getPlayers()[0]
        );

        const uniform = this.resolveUniform(
            serializationContext,
            fragment.getPlayers()[0]
        );

        return `BBAR:${result},${team},${uniform},${spot}`;
    }
}
